import React, { useState } from "react";

import {
  HistoryContainer,
  HistoryBox,
  Title,
  CardsContainer,
  Results,
  CardBox,
  Card,
  CardSymbol,
  CardSuit,
  Subtext,
  MainBtn,
} from "./DetailedHistoryStyled";
import { OPWrapper } from "../settings/SettingsStyled";

import {
  handleCardSymbol,
  handleCardSubText,
  handleCardSuit,
} from "../../helpers/getCards";

export default ({
  handleAbove,
  aboveAnim,
  handleAboveAnimation,
  cardHistory,
  floorFigure,
  audio,
}) => {
  const [okBtn, setOkBtn] = useState(false);
  const [soundPlayed, setSoundPlayed] = useState(false);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  return (
    <HistoryContainer aboveAnim={aboveAnim}>
      <OPWrapper>
        <HistoryBox aboveAnim={aboveAnim}>
          <Title>History</Title>
          <CardsContainer>
            {cardHistory.map((card, index) => (
              <Results key={index}>
                <CardBox>
                  <Card
                    col={
                      index + 1 < cardHistory.length
                        ? cardHistory[index + 1].action === "CHANGE" && "change"
                        : null
                    }
                  >
                    <CardSymbol
                      col={
                        card.cardName.charAt(0) === "S" ||
                        card.cardName.charAt(0) === "C"
                      }
                    >
                      {handleCardSymbol(card)}
                    </CardSymbol>
                    <CardSuit>{handleCardSuit(card)}</CardSuit>
                  </Card>
                  <p>
                    {card.action === "NONE"
                      ? "START"
                      : floorFigure(card.coef, 2) + "x"}
                  </p>
                </CardBox>
                <Subtext>{handleCardSubText(index, cardHistory)}</Subtext>
              </Results>
            ))}
          </CardsContainer>
        </HistoryBox>
        <MainBtn
          set={okBtn}
          soundPlayed={soundPlayed}
          onClick={() => {
            setAnimation(okBtn, setOkBtn);
            audio();
            setSoundPlayed(true);
            setTimeout(() => {
              handleAboveAnimation(false);
              setTimeout(() => {
                handleAbove(false);
              }, 400);
            }, 200);
          }}
        >
          ok
        </MainBtn>
      </OPWrapper>
    </HistoryContainer>
  );
};
